// extracted by mini-css-extract-plugin
export default {"obraL3":"ObraL3_obraL3__WW-fk","pieGraph":"ObraL3_pieGraph__DyDBD","graph":"ObraL3_graph__dMIjt"};